import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/zasilky',
    name: 'shipments',
    meta: { moduleId: 'shipments' },
    component: () => import(/* webpackChunkName: "orders" */ '@/views/shipments/Upload.vue'),
    beforeEnter: isAuthenticated,
  },
];
